import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import Brightness5Icon from "@mui/icons-material/Brightness5";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/actions";
import logo from 'assets/images/logo.jpg';

const Header = ({ handleDrawerToggle }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [greeting, setGreeting] = useState("Good Morning");
  const [GreetingIcon, setGreetingIcon] = useState(WbSunnyIcon);
  const user = useSelector((state) => state?.admin?.userInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour >= 12 && hour < 18) {
      setGreeting("Good Afternoon");
      setGreetingIcon(() => Brightness5Icon);
    } else if (hour >= 18) {
      setGreeting("Good Evening");
      setGreetingIcon(() => NightsStayIcon);
    } else {
      setGreeting("Good Morning");
      setGreetingIcon(() => WbSunnyIcon);
    }
  }, []);

  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    setAnchorEl(null);
  };

  // Proper color per icon (morning, afternoon, evening)
  const getIconColor = () => {
    if (GreetingIcon === WbSunnyIcon) return "#FFA726"; // orange
    if (GreetingIcon === Brightness5Icon) return "#42A5F5"; // blue
    if (GreetingIcon === NightsStayIcon) return "#5C6BC0"; // indigo
    return theme.palette.text.primary;
  };

  return (
    <AppBar  position="fixed"
      className="admin-appbar"
      sx={{
        // width: { sm: `calc(100% - 230px)` },
        ml: { sm: `230px` },
        backgroundColor: '#fff',
        zIndex: 1300,
        boxShadow: 'none',
      }}>
      <Toolbar className="admin-toolbar" sx={{ justifyContent: "space-between" }}>
        {/* Left Section */}
        <Box className="admin-left" display="flex" alignItems="center" gap={1.5}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            className="mobile-menu-trigger"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>

          <Box display="flex" alignItems="center" gap={1}>
          <Box className="">
            <img src={logo} alt="Logo" className="sidebar-logo" />
          </Box>
            <Typography variant="h6" noWrap className="admin-greeting">
              {greeting}, {user?.name || "Admin"}
            </Typography>
            <GreetingIcon
              sx={{
                fontSize: 22,
                color: getIconColor(),
                mt: "2px",
              }}
            />
          </Box>
        </Box>

        {/* Right Section */}
        <Box className="admin-header-icons" display="flex" alignItems="center" gap={1.5}>
          {/* <IconButton color="inherit" sx={{ color: theme.palette.text.secondary }}>
            <Badge badgeContent={5} color="error">
              <NotificationsIcon sx={{ fontSize: 22 }} />
            </Badge>
          </IconButton> */}

          <Box
            className="admin-profile"
            onClick={handleProfileMenuOpen}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              ml: 1,
              px: 1.2,
              py: 0.6,
              borderRadius: "8px",
              transition: "0.2s",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.05)",
              },
            }}
          >
            <Avatar
              alt="Admin User"
              src={user?.profileImage?.signedUrl || "/static/images/avatar/1.jpg"}
              sx={{
                width: 34,
                height: 34,
                mr: 1,
                border: `1px solid ${theme.palette.divider}`,
              }}
            />
            <Typography variant="body2" className="admin-username" sx={{ fontWeight: 500 }}>
              {user?.name || "Admin"}
            </Typography>
          </Box>
        </Box>

        {/* Profile Menu */}
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem
            onClick={() => {
              navigate("/admin/my-profile");
              setAnchorEl(null);
            }}
          >
            My Profile
          </MenuItem>
          {/* <MenuItem onClick={handleMenuClose}>Account Settings</MenuItem> */}
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
